import { BaseModel } from './base.model';

export class AnalyticPreset extends BaseModel {
  id: string;
  name: string;
  description: string;
  presets: { [propertyName: string]: any };
}
